class EmployeeCompensationConceptViewController extends MUIViewController
{
    static newInstance() : EmployeeCompensationConceptViewController {
        let vc = new EmployeeCompensationConceptViewController("employee-compensation-concept-view");
        vc.initWithResource("layout/employee_compensataion_concept/EmployeeCompensationConceptView.html");
        return vc;
    }

    private addButton:MUIButton = null;
    private tableView:UITableView = null;                    

    viewDidLoad(){
        super.viewDidLoad();

        this.addButton = MUIOutlet(this, 'add-btn', 'MUIButton');
        this.addButton.setAction(this, function(this:EmployeeCompensationConceptViewController){
           this.addConcept();
        });

        this.tableView = MUIOutlet(this,"table-view", "UITableView");
        this.tableView.dataSource = this;
        this.tableView.delegate = this;
    }

    viewWillAppear(animated?){
        super.viewWillAppear(animated);        
        this.updateUI();
    }

    private updateUI(){
        if (this.viewIsLoaded == false) return;

        this.fetchedResultsController = null;
        this.tableView.reloadData();
    }
    
    numberOfSections(tableView:UITableView){
        return this.fetchedResultsController.sections.length;
    }
    
    numberOfRowsInSection(tableView:UITableView, section){
        let sec = this.fetchedResultsController.sections[section];
        return sec.numberOfObjects();
    }
    
    cellAtIndexPath(tableView:UITableView, indexPath:MIOIndexPath){
        let cell = tableView.dequeueReusableCellWithIdentifier('ConceptCell') as EmployeeConceptCell;    
        let item = this.fetchedResultsController.objectAtIndexPath(indexPath) as EmployeeCompensationConcept;
        cell.item = item;
            
        return cell;
    }
        
    /*
    didSelectCellAtIndexPath(tableView:UITableView, indexPath:MIOIndexPath){
        let item = this.fetchedResultsController.objectAtIndexPath(indexPath) as EmployeePayrollConcept;

        let vc = EmployeePayrollConceptDetailViewController.newInstance();
        vc.item = item;

        this.navigationController.pushViewController(vc, true);
    }
    */

    editingStyleForRowAtIndexPath(tableView:UITableView, indexPath:MIOIndexPath) {        
        return UITableViewCellEditingStyle.Delete;
    }
    
    commitEditingStyleForRowAtIndexPath(tableView:UITableView, editingStyle:UITableViewCellEditingStyle, indexPath:MIOIndexPath) {
        let item = this.fetchedResultsController.objectAtIndexPath(indexPath) as EmployeeCompensationConcept;    

        if (editingStyle == UITableViewCellEditingStyle.Delete) {
            DBHelper.deleteObjectFromMainContext(item, true);
        }
    }

    private _fetchedResultsController:MIOFetchedResultsController = null;
    set fetchedResultsController(value){
        if (value == null && this._fetchedResultsController != null)
            this._fetchedResultsController.delegate = null;
    
        this._fetchedResultsController = value;
    }
    
    get fetchedResultsController(){
        if (this._fetchedResultsController != null)
            return this._fetchedResultsController;
    
        let ad = MUIWebApplication.sharedInstance().delegate;
    
        let sortDescriptors = [MIOSortDescriptor.sortDescriptorWithKey('title', true)];
        let fetchRequest = DBHelper.listFetchRequestWithEntityName("EmployeeCompensationConcept", sortDescriptors, null);
    
        let fetchedResultsController = new MIOFetchedResultsController();
        fetchedResultsController.initWithFetchRequest(fetchRequest, ad.managedObjectContext, null);
        fetchedResultsController.delegate = this;
    
        fetchedResultsController.performFetch();
    
        this._fetchedResultsController = fetchedResultsController;    
        return this._fetchedResultsController;
    }
    
    controllerDidChangeContent(controller){
        this.tableView.reloadData();
    }

    private addConcept(){
        let avc = new MUIAlertViewController();
        avc.initWithTitle(MIOLocalizeString("NEW_CONCEPT", "NEW CONCEPT"), MIOLocalizeString("CHOOSE_A_TITLE", "CHOOSE A TITLE"), MUIAlertViewStyle.Default);
        avc.addTextFieldWithConfigurationHandler(this, function(textField:MUITextField){
            textField.setPlaceholderText(MIOLocalizeString("TITLE","TITLE"));
        });
        
        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString('ADD','ADD'), MUIAlertActionStyle.Default, this, function(){
            let name = avc.textFields[0].text.trim();            

            if (name.length == 0) {
                AppHelper.showErrorMessage(this, MIOLocalizeString('ERROR', 'ERROR'), MIOLocalizeString("CHECK_TITLE", "CHECK TITLE"));
                return;
            }
            
            let moc = MUIWebApplication.sharedInstance().delegate.managedObjectContext;
            let concept = MIOEntityDescription.insertNewObjectForEntityForName("EmployeeCompensationConcept", moc) as EmployeeCompensationConcept;
            concept.identifier = MIOUUID.UUID().UUIDString;
            concept.title = name;
            concept.key = name.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^\w\s-]/g, '').replace(/\s+/g, '-');
            DBHelper.saveMainContext();
        }));

        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString('CANCEL','CANCEL'), MUIAlertActionStyle.Cancel, this, function(){}));
        
        this.presentViewController(avc, true);
    }
}